export default {
  inputFocused: function (input_form_key) {
    var comp = this;
    comp.$root.focusedInputKey = input_form_key;
    if (comp.$root.keyStrokeDynamics[input_form_key] == undefined) {
      comp.$root.keyStrokeDynamics[input_form_key] = {
        charCount: 0,
        keyPressCount: 0,
        focusedDuration: 0,
        lastFocusTimeStamp: Date.now(),
      };
    } else {
      comp.$root.keyStrokeDynamics[input_form_key].lastFocusTimeStamp =
        Date.now();
    }
    // console.log("inputFocused()__");
    // console.log(comp.$root.keyStrokeDynamics[input_form_key]);
  },

  inputChanged: function (input_form_key) {
    var comp = this;
    comp.$root.keyStrokeDynamics[input_form_key].keyPressCount++;
  },

  inputBlured: function (input_form_key) {
    var comp = this;
    comp.$root.keyStrokeDynamics[input_form_key].charCount =
      comp.$root.formData[input_form_key].length;
    comp.$root.keyStrokeDynamics[input_form_key].focusedDuration +=
      Date.now() -
      comp.$root.keyStrokeDynamics[input_form_key].lastFocusTimeStamp;
    if (comp.$root.focusedInputKey == input_form_key) {
      comp.$root.focusedInputKey = null;
    }
  },
};
